<div class="form-section">
  <h3 class="section-title">{{ 'branchSettings.header' | translate }}</h3>
  <div class="fields-wrapper">
    <app-searchable-select
      [label]="'branchSettings.name' | translate"
      [value]="branchId"
      (valueChange)="onBranchChange($event)"
      [options]="branches"
      [displayWith]="branchLabel"
      [valueWith]="branchValue"
      [emptyLabel]="'branchSettings.noBranch' | translate"
      [emptyValue]="null"
    ></app-searchable-select>

    <div *ngIf="selectedBranch && branchVariablesForm" [formGroup]="branchVariablesForm" class="dynamic-fields">
      <ng-container *ngFor="let varName of getBranchVariableNames()">
        <div *ngIf="isBranchCountryVariable(varName); else branchTextField" class="branch-country-field">
          <app-country-select
            [formControlName]="varName"
            [label]="getBranchVariableLabel(varName) | translate"
            [errorStateMatcher]="errorStateMatcher"
          ></app-country-select>
          <p class="branch-country-hint" *ngIf="!isBranchVariableOverridable(varName)">
            {{ 'branchSettings.readOnlyFromBranch' | translate }}
          </p>
        </div>
        <ng-template #branchTextField>
          <mat-form-field appearance="outline">
            <mat-label>{{ getBranchVariableLabel(varName) | translate }}</mat-label>
            <input
              matInput
              [formControlName]="varName"
              type="text"
              [errorStateMatcher]="errorStateMatcher"
              [readonly]="!isBranchVariableOverridable(varName)">
            <mat-hint *ngIf="!isBranchVariableOverridable(varName)">
              {{ 'branchSettings.readOnlyFromBranch' | translate }}
            </mat-hint>
            <mat-error *ngIf="branchVariablesForm.hasError('required', [varName])">
              {{ 'fieldRequired' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
